import Papa from "papaparse";
import React, { useEffect, useRef, useState } from "react";
import { adminReqConfig, api } from "../../include/api";
import "../../styles/Super.css";
import AdminHeader from "./Header";
import { ChevronDown, X } from "react-feather";
import { useNotification } from "../../Toast/ToastProvider";
import {
  APPROVAL_OPTIONS,
  CustomColoredDropdown,
  FilterPanel,
  formatInvoiceId,
  formatShortMonthDateYearWithTime,
  getAdmin,
  PAYMENT_OPTIONS,
  STATUS_OPTIONS,
} from "../../include/function";
import { useNavigate, useSearchParams } from "react-router-dom";

const ListInvoice = ({ from }) => {
  const [fetchLoading, setFetchLoading] = useState(true);
  const [orderData, setOrderData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const toast = useNotification();
  const [selectedData, setSelectedData] = useState([]);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const user = getAdmin();
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get("q") || "";
  const [searchQuery, setSearchQuery] = useState(initialQuery);
  const [statusLoading, setStatusLoading] = useState(null);
  useEffect(() => {
    const q = searchParams.get("q") || "";
    setSearchQuery(q);
  }, [searchParams]);
  const [productPermissions, setProductPermissions] = useState({
    add: false,
    view: false,
    edit: false,
    delete: false,
  });
  useEffect(() => {
    const fetchPermissions = async () => {
      if (!user?.roleId) return;
      try {
        const res = await api.get(
          `/role_permission/?roleId=${user.roleId}`,
          adminReqConfig(),
        );
        if (res.status === 200 && Array.isArray(res.data.data)) {
          // Find permission entry where pageTitle === "Product"
          const productPerm = res.data.data.find(
            (p) => p.pageTitle === "Sales Invoices",
          );
          if (productPerm) {
            setProductPermissions({
              add: productPerm.add === "true" || productPerm.add === 1,
              view: productPerm.view === "true" || productPerm.view === 1,
              edit: productPerm.edit === "true" || productPerm.edit === 1,
              delete: productPerm.delete === "true" || productPerm.delete === 1,
            });
          }
        }
      } catch (err) {
        console.warn("Failed to fetch product permissions", err);
      }
    };
    fetchPermissions();
  }, [user?.roleId]);
  //Filter values (all optional)
  const [filterValues, setFilterValues] = useState({
    date: "",
    status: "",
    paymentType: "",
    customerType: "",
    productId: "",
    brandId: "",
    categoryId: "",
    timePeriod: "",
    fromDate: "",
    toDate: "",
  });
  //Fetch filter options on mount
  useEffect(() => {
    // Brands
    api
      .get("/brand/", adminReqConfig())
      .then((res) => setBrands(res.data.data || []))
      .catch(() => setBrands([]));
    // Main categories (parent_id = 0)
    api
      .get("/category/?flag=exceptHome", adminReqConfig())
      .then((res) => setCategories(res.data.data || []))
      .catch(() => setCategories([]));
    // Products (limit to avoid overload)
    api
      .get("/product/?limit=200", adminReqConfig())
      .then((res) => setProducts(res.data.data || []))
      .catch(() => setProducts([]));
  }, []);

     // when filter category choose particular brand and product logic ---start---
      const [filteredBrands, setFilteredBrands] = useState([]);
      const [filteredProducts, setFilteredProducts] = useState([]);
  
      const handleFilterChange = (key, value) => {
        setFilterValues((prev) => {
          const newFilters = { ...prev, [key]: value };
  
          if (key === "categoryId") {
            newFilters.brandId = "";
            newFilters.productId = "";
          } else if (key === "brandId") {
            newFilters.productId = "";
          }
  
          return newFilters;
        });
      };
      useEffect(() => {
        if (filterValues.categoryId) {
          const categoryBrands = brands.filter(
            (brand) =>
              brand.categoryId?.toString() === filterValues.categoryId.toString(),
          );
          setFilteredBrands(categoryBrands);
        } else {
          setFilteredBrands(brands); // Show all brands if no category selected
        }
      }, [filterValues.categoryId, brands]);
 useEffect(() => {
   let filtered = products;

   if (filterValues.categoryId) {
     filtered = filtered.filter(
       (product) =>
         product.category?.[0]?.categoryId?.toString() ===
         filterValues.categoryId.toString(),
     );
   }

   if (filterValues.brandId) {
     filtered = filtered.filter(
       (product) =>
         product.brandId?.toString() === filterValues.brandId.toString(),
     );
   }

   setFilteredProducts(filtered);
 }, [filterValues.categoryId, filterValues.brandId, products]);
    useEffect(() => {
       api
         .get("/category/?flag=exceptHome", adminReqConfig())
         .then((res) => setCategories(res.data.data || []))
         .catch(() => setCategories([]));
      api
        .get("/brand/", adminReqConfig())
        .then((res) => setBrands(res.data.data || []))
        .catch(() => setBrands([]));
  
  
      api
        .get("/product/?limit=200", adminReqConfig())
        .then((res) => setProducts(res.data.data || []))
        .catch(() => setProducts([]));
    }, []);
  // ------end-------
  

  //Fetch orders with filters
  const getOrder = (filters = {}) => {
    setFetchLoading(true);
    const params = new URLSearchParams();
    if (filters.date) params.set("date", filters.date);
    if (filters.fromDate) params.set("fromDate", filters.fromDate);
    if (filters.toDate) params.set("toDate", filters.toDate);
    if (filters.status) params.set("status", filters.status);
    if (filters.paymentType) params.set("paymentType", filters.paymentType);
    if (filters.paymentStatus)
      params.set("paymentStatus", filters.paymentStatus);
    if (filters.customerType) params.set("customerType", filters.customerType);
    if (filters.productId) params.set("productId", filters.productId);
    if (filters.brandId) params.set("brandId", filters.brandId);
    if (filters.categoryId) params.set("categoryId", filters.categoryId);
    let url = "/super_sales_invoice/";
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    api
      .get(url, adminReqConfig())
      .then((response) => {
        if (response.status === 200 && Array.isArray(response.data.data)) {
          // Sort by date in descending order (newest first)
          const sortedData = response.data.data.sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            return dateB - dateA; // Descending order
          });
          const normalizedData = sortedData.map((order) => ({
            ...order,
            orderItems: (order.orderItems || []).map((item) => ({
              ...item,
              paymentStatus: item.paymentStatus?.toLowerCase(),
              status: item.status?.toLowerCase(),
            })),
          }));
          setOrderData(normalizedData);
          setFilteredData(normalizedData);
        } else {
          setOrderData([]);
          setFilteredData([]);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch invoice:", error);
        setOrderData([]);
        setFilteredData([]);
      })
      .finally(() => setFetchLoading(false));
  };
  //Initial load
  useEffect(() => {
    getOrder();
  }, []);


  //Search
useEffect(() => {
  if (!searchQuery.trim()) {
    setFilteredData(orderData);
    return;
  }

  const query = searchQuery.toLowerCase().trim();

  const filtered = orderData.filter((order) => {
    // Helper: Format invoice ID for comparison
    const getFormattedInvoiceId = (ord) => {
      if (!ord?.createTimestamp || !ord?.id) return "INV--";
      const year = new Date(ord.createTimestamp).getFullYear();
      const yy = String(year).slice(-2);
      const paddedId = String(ord.id).padStart(4, "0");
      return `INV${yy}-${paddedId}`;
    };

    const invoiceId = getFormattedInvoiceId(order);

    return (
      order.id?.toString().startsWith(query) ||
      invoiceId.toLowerCase().startsWith(query) ||
      order.name?.toLowerCase().startsWith(query) ||
      order.customerName?.toLowerCase().startsWith(query) ||
      order.customerType?.toLowerCase().startsWith(query) ||
      order.orderItems?.some(
        (item) =>
          item.productName?.toLowerCase().startsWith(query) ||
          item.variant?.toLowerCase().startsWith(query),
      )
    );
  });

  setFilteredData(filtered);
  setCurrentPage(1);
}, [searchQuery, orderData, searchParams]);


  const handleStatusChange = (orderId, itemId, value) => {
    const order = orderData.find((o) => o.id === orderId);
    if (!order) {
      toast({ type: "error", message: "Order not found" });
      return;
    }

    // Find the item to get current status
    const orderItem = order.orderItems.find((item) => item.id === itemId);
    const currentStatus = orderItem?.status?.toLowerCase();

    // If rejecting from need-approval, set final status as rejected
    if (value === "rejected") {
      setStatusLoading({ orderId, itemId });
      const payload = {
        status: "rejected",
        customerId: order.customerId,
      };
      const url = `/orders/?id=${orderId}&flag=changecreditstatus`;
      api
        .put(url, payload, adminReqConfig())
        .then((response) => {
          if (response.status === 200) {
            toast({ type: "success", message: "Order Rejected" });
            setOrderData((prev) =>
              prev.map((order) =>
                order.id === orderId
                  ? {
                      ...order,
                      // FIX: Update ALL items in the order, not just one
                      orderItems: order.orderItems.map((item) => ({
                        ...item,
                        status: "rejected",
                      })),
                    }
                  : order,
              ),
            );
          } else {
            toast({ type: "error", message: "Failed to reject order" });
          }
        })
        .catch((error) => {
          console.error("Status update error:", error);
          toast({ type: "error", message: "Error updating status" });
        })
        .finally(() => {
          setStatusLoading(null);
        });
      return;
    }

    // If approving from need-approval, move to "ordered" status
    if (value === "approved") {
      setStatusLoading({ orderId, itemId });
      const payload = {
        status: "approved",
        customerId: order.customerId,
      };
      const url = `/orders/?id=${orderId}&flag=changecreditstatus`;
      api
        .put(url, payload, adminReqConfig())
        .then((response) => {
          if (response.status === 200) {
            toast({ type: "success", message: "Order Approved" });
            setOrderData((prev) =>
              prev.map((order) =>
                order.id === orderId
                  ? {
                      ...order,
                      // FIX: Update ALL items in the order, not just one
                      orderItems: order.orderItems.map((item) => ({
                        ...item,
                        status: "ordered",
                      })),
                    }
                  : order,
              ),
            );
          } else {
            toast({ type: "error", message: "Failed to approve order" });
          }
        })
        .catch((error) => {
          console.error("Status update error:", error);
          toast({ type: "error", message: "Error updating status" });
        })
        .finally(() => {
          setStatusLoading(null);
        });
      return;
    }

    // Normal status change (for non need-approval statuses) - Keep as is
    setStatusLoading({ orderId, itemId });
    const payload = {
      status: value,
      customerId: order.customerId,
    };
    const url = `/orders/?id=${itemId}&flag=changestatus`;
    api
      .put(url, payload, adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          toast({ type: "success", message: "Status updated successfully" });
          setOrderData((prev) =>
            prev.map((order) =>
              order.id === orderId
                ? {
                    ...order,
                    orderItems: order.orderItems.map((item) =>
                      item.id === itemId ? { ...item, status: value } : item,
                    ),
                  }
                : order,
            ),
          );
        } else {
          toast({ type: "error", message: "Failed to update status" });
        }
      })
      .catch((error) => {
        console.error("Status update error:", error);
        toast({ type: "error", message: "Error updating status" });
      })
      .finally(() => {
        setStatusLoading(null);
      });
  };
  //Pagination logic
  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;
  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  //Close filter panel on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isFilterPanelOpen && !e.target.closest(".nav-item")) {
        setIsFilterPanelOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isFilterPanelOpen]);
//Export handlers (CSV)
const handleDownloadCSV = (exportScope = "current") => {
  let dataToExport = [];

  //  PRIORITY 1: If items selected → ALWAYS export selected (overrides everything)
  if (selectedData.length > 0) {
    dataToExport = orderData.filter((order) => selectedData.includes(order.id));
  } 
  //  PRIORITY 2: If "Export All" clicked → export entire dataset
  else if (exportScope === "all") {
    dataToExport = orderData;
  } 
  //  PRIORITY 3: Default → export current page items only
  else {
    dataToExport = currentItems;
  }

  if (dataToExport.length === 0) {
    toast({ type: "error", message: "No order data to download" });
    return;
  }

  const csvRows = [];
  let serialNo = 1;
  dataToExport.forEach((order) => {
    const baseOrderInfo = {
      "S.No": serialNo,
      "Order ID": order.id || "-",
      "Customer Name": order.name || "-",
      Phone: order.phoneNumber || "-",
      "Order Date": order.date ? new Date(order.date).toLocaleString("en-IN") : "-",
      "Delivery Address": order.address || "-",
      "Delivery City": order.city || "-",
      "Delivery State": order.state || "-",
      "Total Amount": order.totalAmount || 0,
      "Payment Mode": order.orderItems?.[0]?.paymentMode || "-",
      "Payment Status": order.orderItems?.[0]?.paymentStatus || "-",
      "Payment Info": order.orderItems?.[0]?.paymentInfo || "-",
    };
    if (!order.orderItems || order.orderItems.length === 0) {
      csvRows.push({
        ...baseOrderInfo,
        "Item ID": "", "Product ID": "", "Product Name": "",
        Qty: "", "Price per Unit": "", "Item Amount": "",
        "Discount Mode": "", "Discount Value": "", "Discount Label": "",
        "Main Image URL": "", "Item Status": "", "Shop ID": "",
      });
      serialNo++;
    } else {
      order.orderItems.forEach((item) => {
        csvRows.push({
          ...baseOrderInfo,
          "S.No": serialNo++,
          "Item ID": item.id || "-",
          "Product ID": item.productId || "-",
          "Product Name": item.productName || "-",
          Qty: item.qty || 0,
          "Price per Unit": item.price || 0,
          "Item Amount": item.amount || 0,
          "Discount Mode": item.discountMode || "-",
          "Discount Value": item.discountValue || 0,
          "Discount Label": item.discountLabel || "-",
          "Main Image URL": item.mainImage || "-",
          "Item Status": item.status || "-",
          "Shop ID": item.shopId || "-",
        });
      });
    }
  });

  const columns = [
    "S.No", "Order ID", "Customer Name", "Phone",
    "Delivery Address", "Delivery City", "Delivery State", "Total Amount",
    "Payment Mode", "Payment Status", "Payment Info",
    "Item ID", "Product ID", "Product Name", "Qty", "Price per Unit",
    "Item Amount", "Discount Mode", "Discount Value", "Discount Label",
    "Main Image URL", "Item Status", "Shop ID",
  ];

  //  CORRECT SYNTAX: fields + data keys
  const csv = Papa.unparse({
    fields: columns,
    data: csvRows.map((row) => {
      return columns.map((col) => row[col]);
    })
  });

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  
  // Dynamic filename based on export type
  const fileName = selectedData.length > 0 
    ? `Invoice_Selected_${selectedData.length}.csv`
    : exportScope === "all" 
      ? "Invoice_All.csv" 
      : `Invoice_Page${currentPage}.csv`;
    
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
  //Row expand/collapse
  const toggleExpand = (orderId) => {
    setExpandedRows((prev) =>
      prev.includes(orderId)
        ? prev.filter((id) => id !== orderId)
        : [...prev, orderId],
    );
  };
  const handleOrderDetailClick = (orderId) => {
    navigate(`/admin/invoice-details/${orderId}`);
  };
  //Selection handlers
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = currentItems.map((p) => p.id);
      setSelectedData((prev) => [...new Set([...prev, ...allIds])]);
    } else {
      const idsToRemove = currentItems.map((p) => p.id);
      setSelectedData((prev) => prev.filter((id) => !idsToRemove.includes(id)));
    }
  };
  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id],
    );
  };
  //Apply & Clear filters
  const applyFilters = () => {
    let finalFilters = { ...filterValues };
    // Handle timePeriod presets
    if (filterValues.timePeriod && filterValues.timePeriod !== "period") {
      const now = new Date();
      let fromDate = "";
      let toDate = "";
      switch (filterValues.timePeriod) {
        case "today":
          fromDate = toDate = now.toISOString().split("T")[0];
          break;
        case "yesterday":
          const yesterday = new Date(now);
          yesterday.setDate(now.getDate() - 1);
          fromDate = toDate = yesterday.toISOString().split("T")[0];
          break;
        case "thisMonth":
          fromDate = `${now.getFullYear()}-${String(
            now.getMonth() + 1,
          ).padStart(2, "0")}-01`;
          toDate = now.toISOString().split("T")[0];
          break;
        case "last3Months":
          const threeMonthsAgo = new Date(now);
          threeMonthsAgo.setMonth(now.getMonth() - 3);
          fromDate = threeMonthsAgo.toISOString().split("T")[0];
          toDate = now.toISOString().split("T")[0];
          break;
        case "thisYear":
          fromDate = `${now.getFullYear()}-01-01`;
          toDate = `${now.getFullYear()}-12-31`;
          break;
        case "all":
        default:
          fromDate = toDate = "";
      }
      finalFilters = {
        ...finalFilters,
        fromDate,
        toDate,
      };
    }
    // Clear the old `date` filter if using range
    if (finalFilters.timePeriod) {
      finalFilters.date = ""; // because backend uses either `date` OR `fromDate/toDate`
    }
    getOrder(finalFilters);
    setIsFilterPanelOpen(false);
  };
  const clearFilters = () => {
    const empty = {
      date: "",
      status: "",
      paymentType: "",
      customerType: "",
      productId: "",
      brandId: "",
      categoryId: "",
    };
    setFilterValues(empty);
    getOrder(empty);
    setIsFilterPanelOpen(false);
  };

  

  const getDisabledStatuses = (currentStatus) => {
    const status = currentStatus?.toLowerCase();
    const disabled = [];

    switch (status) {
      case "rejected":
        disabled.push(
          "ordered",
          "confirmed",
          "packed",
          "shipped",
          "delivered",
          "return",
          "cancelled",
          "approved",
        );
        break;
      case "ordered":
        break;
      case "confirmed":
        disabled.push("ordered", "approved", "rejected");
        break;
      case "packed":
        disabled.push("ordered", "confirmed", "approved", "rejected");
        break;
      case "shipped":
        disabled.push("ordered", "confirmed", "approved", "rejected", "packed");
        break;
      case "delivered":
        disabled.push(
          "ordered",
          "confirmed",
          "approved",
          "rejected",
          "packed",
          "shipped",
        );
        break;
      case "return":
        disabled.push(
          "ordered",
          "confirmed",
          "packed",
          "shipped",
          "delivered",
          "cancelled",
          "approved",
          "rejected",
        );
        break;
      case "cancelled":
        disabled.push(
          "ordered",
          "confirmed",
          "packed",
          "shipped",
          "delivered",
          "return",
          "approved",
          "rejected",
        );
        break;
      default:
        break;
    }
    return disabled;
  };

  return (
    <>
      <AdminHeader title={"INVOICE LIST"}>
        <div className="content-wrapper p-0">
          <section
            style={{
              backgroundColor: "#F1F4F9",
              padding: "30px",
              marginTop: "70px",
              marginBottom: "40px",
              minHeight: "80vh",
            }}
          >
            {fetchLoading ? (
              <p>Loading orders...</p>
            ) : (
              <>
                <div className="rounded-5 bg-white py-24">
                  <div className="row align-items-center px-24 py-10 mb-3">
                    <div className="col-auto">
                      <h6 className="mb-0">All Invoice List</h6>
                    </div>
                    <div className="col d-flex align-items-center">
                      <div
                        className="nav-item"
                        style={{ position: "relative" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #c6d6f5",
                            borderRadius: "8px",
                            backgroundColor: "#fff",
                            width: "500px",
                          }}
                        >
                          <img
                            src="/assets/images/search-icon.png"
                            style={{ width: "18px", marginLeft: "8px" }}
                          />
                          <input
                            type="text"
                            placeholder="Filter and search here..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onFocus={() => setIsFilterPanelOpen(true)}
                            style={{
                              border: "none",
                              outline: "none",
                              padding: "8px 8px",
                              width: "100%",
                              fontSize: "14px",
                              color: "#333",
                              backgroundColor: "transparent",
                            }}
                            />
                             {searchQuery && (
                                                      <X
                                                        size={24}
                                                        onClick={(e) => {
                                                          e.stopPropagation(); 
                                                          setSearchQuery(""); 
                                                          setCurrentPage(1);
                                                          setIsFilterPanelOpen(false);
                                                        }}
                                                        style={{
                                                          position: "absolute",
                                                          right: "40px", 
                                                          cursor: "pointer",
                                                          color: "#999",
                                                          padding: "4px",
                                                          zIndex: 10,
                                                        }}
                                                        onMouseEnter={(e) =>
                                                          (e.currentTarget.style.color = "#666")
                                                        }
                                                        onMouseLeave={(e) =>
                                                          (e.currentTarget.style.color = "#999")
                                                        }
                                                      />
                                                    )}
                          <ChevronDown
                            size={16}
                            style={{
                              marginRight: "8px",
                              color: "#999",
                              cursor: "pointer",
                              transform: isFilterPanelOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "transform 0.2s",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsFilterPanelOpen(!isFilterPanelOpen);
                            }}
                          />
                        </div>
                        {isFilterPanelOpen && (
                             <FilterPanel
                                                filterValues={filterValues}
                                                onFilterChange={handleFilterChange}
                                                onApply={applyFilters}
                                                onClear={clearFilters}
                                                brands={brands}
                                                categories={categories}
                                                products={products}
                                                filteredBrands={filteredBrands}
                                                filteredProducts={filteredProducts}
                                              />
                        )}
                      </div>
                    </div>
                    <div className="d-flex col-auto">
                      <CustomDropdown handleDownloadCSV={handleDownloadCSV} />
                    </div>
                  </div>
                  {/* Table */}
                  <div className="table-responsive mt-24 product-table">
                    <table className="table table-striped custom-striped-table-product-list align-middle">
                      <thead>
                        <tr>
                          <th scope="col">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              style={{ borderColor: "#c5d5f5" }}
                              onChange={handleSelectAll}
                              checked={
                                currentItems.length > 0 &&
                                currentItems.every((p) =>
                                  selectedData.includes(p.id),
                                )
                              }
                            />
                          </th>
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Invoice ID
                          </th>
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Product Name
                          </th>
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Customer Name
                          </th>
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Billing Name
                          </th>
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Customer Type
                          </th>
                          <th
                            scope="col"
                            style={{
                              fontSize: "15px",
                              textWrap: "nowrap",
                              width: "120px",
                            }}
                          >
                            Date & Time
                          </th>
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Total Amount
                          </th>
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Payment Status
                          </th>
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Billing Address
                          </th>
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length > 0 ? (
                          currentItems.map((order) => {
                            const isMulti = order.orderItems.length > 1;
                            const isExpanded = expandedRows.includes(order.id);
                            const isOverdue =
                              order?.orderItems[0]?.status.toLowerCase() ===
                              "need-approval";
                            return (
                              <React.Fragment key={order.id}>
                                <tr
                                  className={
                                    isOverdue ? "overdue-row" : undefined
                                  }
                                >
                                  <td>
                                    <input
                                      type="checkbox"
                                      style={{ borderColor: "#c5d5f5" }}
                                      className="form-check-input"
                                      checked={selectedData.includes(order.id)}
                                      onChange={() => handleSelectOne(order.id)}
                                    />
                                  </td>
                                  <td>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        textWrap: "nowrap",
                                      }}
                                    >
                                      {order.orderItems.length > 1 && (
                                        <button
                                          style={{
                                            border: "2px solid #006fbf",
                                            color: "#006fbf",
                                            background: "transparent",
                                            borderRadius: "4px",
                                            width: "14px",
                                            height: "14px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: "12px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => toggleExpand(order.id)}
                                        >
                                          {isExpanded ? "−" : "+"}
                                        </button>
                                      )}
                                      <span
                                        className={
                                          isOverdue
                                            ? "over-due-color"
                                            : undefined
                                        }
                                      >
                                        {formatInvoiceId(order)}
                                      </span>
                                    </div>
                                  </td>
                                  <td style={{ width: "15%" }}>
                                    <button
                                      onClick={() =>
                                        handleOrderDetailClick(order.id)
                                      }
                                      style={{
                                        background: "none",
                                        border: "none",
                                        cursor: "pointer",
                                        padding: 0,
                                        fontSize: "inherit",
                                      }}
                                      title="View Order Details"
                                    >
                                      {isMulti ? (
                                        <>
                                          <span
                                            className={
                                              isOverdue
                                                ? "over-due-color"
                                                : undefined
                                            }
                                          >
                                            {order.orderItems[0]?.productName}
                                          </span>
                                          <span
                                            className={
                                              isOverdue
                                                ? "over-due-color"
                                                : "text-primary"
                                            }
                                          >
                                            {" "}
                                            + {order.orderItems.length - 1}{" "}
                                            Items
                                          </span>
                                        </>
                                      ) : (
                                        <span
                                          className={
                                            isOverdue
                                              ? "over-due-color"
                                              : undefined
                                          }
                                        >
                                          {order.orderItems[0]?.productName}
                                        </span>
                                      )}
                                    </button>
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      {order.customerName}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      {order.name}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      {order.customerType}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      {formatShortMonthDateYearWithTime(
                                        order.createTimestamp,
                                      )}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      ₹
                                      {Math.round(
                                        order.totalAmount,
                                      ).toLocaleString()}
                                    </span>
                                  </td>
                                  <td>
                                    <CustomColoredDropdown
                                      value={order.paymentStatus}
                                      options={PAYMENT_OPTIONS}
                                      type="payment"
                                      disable={true}
                                    />
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      {order.address}, {order.locality},{" "}
                                      {order.city},{order.state}
                                    </span>
                                  </td>
                                  <td>
                                    {!isMulti &&
                                      (order.orderItems[0]?.status?.toLowerCase() ===
                                      "need-approval" ? (
                                        <CustomColoredDropdown
                                          value={order.orderItems[0]?.status}
                                          options={APPROVAL_OPTIONS}
                                          disabledOptions={[]}
                                          type="approval"
                                          loading={
                                            statusLoading?.orderId ===
                                              order.id &&
                                            statusLoading?.itemId ===
                                              order.orderItems[0]?.id
                                          }
                                          onChange={(val) =>
                                            handleStatusChange(
                                              order.id,
                                              order.orderItems[0]?.id,
                                              val,
                                            )
                                          }
                                        />
                                      ) : (
                                        <CustomColoredDropdown
                                          value={order.orderItems[0]?.status}
                                          options={STATUS_OPTIONS.filter(
                                            (opt) =>
                                              opt.value !== "need-approval",
                                          )}
                                          disabledOptions={getDisabledStatuses(
                                            order.orderItems[0]?.status,
                                          )}
                                          type="status"
                                          loading={
                                            statusLoading?.orderId ===
                                              order.id &&
                                            statusLoading?.itemId ===
                                              order.orderItems[0]?.id
                                          }
                                          onChange={(val) =>
                                            handleStatusChange(
                                              order.id,
                                              order.orderItems[0]?.id,
                                              val,
                                            )
                                          }
                                        />
                                      ))}
                                  </td>
                                </tr>
                                {isExpanded &&
                                  order.orderItems.map((item, idx) => (
                                    <tr key={item.id} className="bg-light">
                                      <td></td>
                                      <td style={{ paddingLeft: "30px" }}>
                                        {idx + 1}.
                                      </td>
                                      <td>
                                        {item.productName || "N/A"}
                                        {item.variant !== "" ? "(" : ""}
                                        {item.variant ? item.variant : ""}
                                        {item.variant !== "" ? ")" : ""}
                                      </td>{" "}
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td>
                                        ₹
                                        {Math.round(
                                          item.amount,
                                        ).toLocaleString()}
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td>
                                        {item.status?.toLowerCase() ===
                                        "need-approval" ? (
                                          <CustomColoredDropdown
                                            value={item.status}
                                            options={APPROVAL_OPTIONS}
                                            disabledOptions={[]}
                                            type="approval"
                                            loading={
                                              statusLoading?.orderId ===
                                                order.id &&
                                              statusLoading?.itemId === item.id
                                            }
                                            onChange={(val) =>
                                              handleStatusChange(
                                                order.id,
                                                item.id,
                                                val,
                                              )
                                            }
                                          />
                                        ) : (
                                          <CustomColoredDropdown
                                            value={item.status}
                                            options={STATUS_OPTIONS.filter(
                                              (opt) =>
                                                opt.value !== "need-approval",
                                            )}
                                            disabledOptions={getDisabledStatuses(
                                              item.status,
                                            )}
                                            type="status"
                                            loading={
                                              statusLoading?.orderId ===
                                                order.id &&
                                              statusLoading?.itemId === item.id
                                            }
                                            onChange={(val) =>
                                              handleStatusChange(
                                                order.id,
                                                item.id,
                                                val,
                                              )
                                            }
                                          />
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                              </React.Fragment>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="11" className="text-center py-3">
                              No Invoice found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* Pagination */}
                  <div className="d-flex justify-content-between align-items-center mt-16 p-16">
                    <div className="d-flex align-items-center">
                      <select
                        className="form-select d-inline-block w-auto"
                        value={itemsPerPage}
                        onChange={(e) => {
                          const val = e.target.value;
                          setItemsPerPage(
                            val === "all" ? "all" : parseInt(val),
                          );
                          setCurrentPage(1);
                        }}
                        style={{
                          height: "34px",
                          fontSize: "14px",
                          minWidth: "70px",
                        }}
                      >
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="all">All</option>
                      </select>
                      <span className="ms-2">
                        Showing {showingFrom} to {showingTo} of{" "}
                        {filteredData.length} Lists
                      </span>
                    </div>
                    <nav>
                      <ul className="pagination mt-0">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginate(currentPage - 1)}
                          >
                            &laquo;
                          </button>
                        </li>
                        {(() => {
                          const pagesToShow = 5;
                          let startPage = Math.max(
                            1,
                            currentPage - Math.floor(pagesToShow / 2),
                          );
                          let endPage = startPage + pagesToShow - 1;
                          if (endPage > totalPage) {
                            endPage = totalPage;
                            startPage = Math.max(1, endPage - pagesToShow + 1);
                          }
                          const pageNumbers = [];
                          for (let i = startPage; i <= endPage; i++) {
                            pageNumbers.push(i);
                          }
                          return pageNumbers.map((pageNum) => (
                            <li
                              key={pageNum}
                              className={`page-item ${
                                currentPage === pageNum ? "active" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => paginate(pageNum)}
                              >
                                {pageNum}
                              </button>
                            </li>
                          ));
                        })()}
                        <li
                          className={`page-item ${
                            currentPage === totalPage ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginate(currentPage + 1)}
                          >
                            &raquo;
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </>
            )}
          </section>
        </div>
      </AdminHeader>
    </>
  );
};
export default ListInvoice;

// --- Dropdown Component ---
const CustomDropdown = ({ handleDownloadCSV }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Options");
  const dropdownRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const options = [
    { label: "Export", value: "export" },
    { label: "Export All", value: "exportAll" },
  ];
  const handleSelect = (opt) => {
    setSelected(opt.label);
    setIsOpen(false);

    if (opt.value === "export") {
      // ✅ Export = current page only (but selected overrides)
      handleDownloadCSV("current");
    } else if (opt.value === "exportAll") {
      // ✅ Export All = entire dataset (but selected overrides)
      handleDownloadCSV("all");
    }

    setSelected("Options");
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);
  return (
    <div
      className="custom-select"
      style={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef}
    >
      <div
        className="select-header"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: isHovered ? "#EDF8FA" : "#fff",
          color: "rgba(129, 134, 134, 1)",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          width: "140px",
          height: "40px",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 500,
          transition: "background-color 0.2s ease",
        }}
      >
        <span>{selected}</span>
        <ChevronDown />
      </div>
      {isOpen && (
        <ul
          className="select-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            backgroundColor: "white",
            border: "none",
            borderRadius: "4px",
            zIndex: 1000,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: 500,
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              onClick={() => handleSelect(opt)}
              className="select-option"
              style={{
                padding: "8px 12px",
                color: "rgba(129, 134, 134, 1)",
                backgroundColor: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};